import { useCallback, useEffect, useState } from 'react';
import HeaderCard from '../../component/cardCustom/headerCard'
import * as Style from "./payMentStyle";
import CustomerAgentApi from '../../api/customer-agent/customer-agent.api';
import TableRowCommon from '../../component/table/TableRowCommon';
import { Col, Row } from 'react-bootstrap';
import InputTextField from '../../component/input/inputTextField';
import TableCustom from '../../component/table/tableCustom';
import { IconButton, Tooltip } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getProfile } from '../../utils/app.utils';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { decode } from 'js-base64';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { colors } from '../../constants/colors';
import { routeName } from '../../routes/routers-name';
import ModalCustom from '../../component/modalCustom/modalCustom';

export default function AgentList() {
    const profile: any = JSON.parse(getProfile() || "{}");
    // const branchId: any = getBranch() ? Number(getBranch()) : undefined

    const [roleId, setRoleId] = useState<number>(JSON.parse(decode(profile))?.roleId);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();
    const [page, setPage] = useState<number>(1)
    const [pageLimit, setPageLimit] = useState<number>(5)
    const [rowCount, setRowCount] = useState<number>(1)
    const [sortBy, setSortBy] = useState<string>('modifiedDate')
    const [sortType, setSortType] = useState<string>('ASC')
    const [search, setSearch] = useState<string>('')
    const [data, setData] = useState<any[]>([]);

    const loadData = useCallback(async () => {

        let condition: any = {
            page: page,
            pageLimit: pageLimit,
            customerId_agent: JSON.parse(decode(profile))?.customerId,

        }
        if (search) condition = { ...condition, search: search }
        // if (sortBy) condition = { ...condition, sortBy: sortBy }
        // if (sortType) condition = { ...condition, sortType: sortType }

        const res = await CustomerAgentApi.by_agent(condition)

        if (res.status === 200) {
            setData(res.data.data.items)

        } else {
            setData([])
        }
    }, [search, page, pageLimit])
    useEffect(() => {
        loadData()
    }, [loadData])
    const headCells = [
        { id: "no", disablePadding: false, label: "ลำดับ", align: 'center', width: 100 },
        { id: "documentDate", disablePadding: false, label: 'ชื่อ-นามสกุล', align: "left", },
        { id: "action", disablePadding: false, align: "center", label: '', },];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1

        const { customer_fullname, userId } = objData;


        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no },

                { option: "TEXT", align: "left", label: customer_fullname || "-" },

                {
                    option: "COMPONENT",
                    align: "center",
                    component: (
                        <div className="d-flex align-items-center justify-content-center mx-auto w-100">

                            <Tooltip title="ดู">
                                <IconButton onClick={() => { history.push(routeName.payBill + '-by-agent/' + userId) }}>
                                    <FontAwesomeIcon
                                        icon={faEye}
                                        style={{
                                            fontSize: "20px",
                                            width: "22px",
                                            color: colors.themeMainColor
                                        }}
                                    />
                                </IconButton>
                            </Tooltip>

                        </div>
                    ),
                },
            ],
        };

        return (
            <TableRowCommon {...objRenderData} />
        );
    };
    return (
        <>
            <HeaderCard text={'ชำระเงินแทน'} />
            <Style.PageContainer>
                <Style.MainContainer>

                    <Row spacing={2}>
                        <Col lg={2} md={12} xs={12} className="my-1">
                            <InputTextField
                                placeholder={'ค้นหา'}
                                label={'ค้นหา'}
                                value={search}
                                onchange={(event) => {
                                    setSearch(event.target.value)
                                    setPage(1)
                                }}
                            />
                        </Col>
                    </Row>
                    <Style.TableContainer>
                        <TableCustom
                            headCells={headCells}
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortType={"ASC"}
                            sortBy=""
                            rowCount={rowCount}
                            rowsData={data.map((d: any, i: number) => {
                                return renderData(d, i);
                            })}
                            onSort={() => { }}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                            tableMinWidth={1400}
                        />
                    </Style.TableContainer>
                </Style.MainContainer>

            </Style.PageContainer>

          
        </>
    )
}
